import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import { PaymentCardFormContainer, SelectPaymentMethod } from 'containers';

const UpdatePaymentMethod = ({ match }) => (
  <Switch>
    <Route
      path={`${match.url}/payment-card`}
      component={PaymentCardFormContainer}
    />
    <Route component={SelectPaymentMethod} />
  </Switch>
);

UpdatePaymentMethod.propTypes = {
  match: PropTypes.object.isRequired
};

export default UpdatePaymentMethod;



// WEBPACK FOOTER //
// ./src/components/UpdatePaymentMethod/UpdatePaymentMethod.js